(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-gs1-pending"]) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-gs1-pending]');
    if (!root) return;
    const params = new URLSearchParams(window.location.search);
    const sku = (params.get('sku') || '').trim().slice(0, 80);
    const gtin = (params.get('gtin') || '').replace(/\D/g, '');
    const title = (params.get('title') || '').trim().slice(0, 120);

    if (title) root.querySelector('[data-gs1-pending-title]').textContent = title;

    let shown = 0;
    const show = (name, value) => {
      const fact = root.querySelector(`[data-gs1-pending-fact="${name}"]`);
      if (!fact || !value) return;
      fact.querySelector('.gs1-product-poster__fact-value').textContent = value;
      fact.hidden = false;
      shown += 1;
    };
    show('sku', sku);
    show('gtin', gtin && gtin.length <= 14 ? gtin.padStart(14, '0') : '');
    if (shown > 0) root.querySelector('[data-gs1-pending-facts]').hidden = false;
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-gs1-product-poster"]) return;
  try {
    
  (() => {
    const poster = document.querySelector('[data-gs1-product-poster]');
    const target = poster?.querySelector('[data-gs1-gtin]');
    if (target) {
      const params = new URLSearchParams(window.location.search);
      const suppliedGtin = (params.get('gtin') || '').replace(/\D/g, '');
      const productBarcode = (target.dataset.productBarcode || '').replace(/\D/g, '');
      const gtin = suppliedGtin || productBarcode;
      if (gtin && gtin.length <= 14) target.textContent = gtin.padStart(14, '0');
      else if (!gtin) target.closest('.gs1-product-poster__fact')?.remove();
    }

    const viewer = poster?.querySelector('[data-gs1-viewer]');
    const viewerImage = viewer?.querySelector('[data-gs1-viewer-image]');
    const viewerTriggers = [...(poster?.querySelectorAll('[data-gs1-viewer-trigger]') || [])];
    let activeImage = 0;
    const showImage = (index) => {
      if (!viewerImage || viewerTriggers.length === 0) return;
      activeImage = (index + viewerTriggers.length) % viewerTriggers.length;
      const trigger = viewerTriggers[activeImage];
      viewerImage.src = trigger.dataset.viewerSrc;
      viewerImage.alt = trigger.dataset.viewerAlt;
    };
    viewerTriggers.forEach((trigger, index) => trigger.addEventListener('click', () => {
      showImage(index);
      viewer?.showModal();
    }));
    viewer?.querySelector('[data-gs1-viewer-previous]')?.addEventListener('click', () => showImage(activeImage - 1));
    viewer?.querySelector('[data-gs1-viewer-next]')?.addEventListener('click', () => showImage(activeImage + 1));
    viewer?.classList.toggle('gs1-product-poster__viewer--single', viewerTriggers.length < 2);
    viewer?.addEventListener('click', (event) => {
      if (event.target === viewer) viewer.close();
    });
    viewer?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showImage(activeImage - 1);
      if (event.key === 'ArrowRight') showImage(activeImage + 1);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
